import React from 'react';
import MapComponent from '../../components/gmap';


function Dashboard({ userData }) {
    console.log(userData);
    return (
        <div className='content-wrappers'>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Dashboard</h3>
                        </div>
                        <div className="card-body">
                            <MapComponent userData={userData} />

                            {
                                userData && userData.role !== 'SUPERADMIN' && (
                                    <div className='table-responsive mt-5'>
                                        <table className='table table-bordered'>
                                            <thead>
                                                <tr>
                                                    <th>Project Name</th>
                                                    <th>Device ID</th>
                                                    <th>System Name</th>
                                                    <th>System Type</th>
                                                    <th>Temperature Range</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    userData?.deviceList.map((device, index) => (
                                                        <tr key={index}>
                                                            <td>{userData?.project_name}</td>
                                                            <td>{device.device_id}</td>
                                                            <td>{device.name}</td>
                                                            <td>{device.system}</td>
                                                            <td>{device.temp_range}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            }
                            {
                                userData && userData.role === 'SUPERADMIN' && (
                                    <div className='table-responsive mt-5'>
                                        <table className='table table-bordered'>
                                            <thead>
                                                <tr>
                                                    <th>Project Name</th>
                                                    <th>Device ID</th>
                                                    <th>System Name</th>
                                                    <th>System Type</th>
                                                    <th>Temperature Range</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    userData?.deviceList.map((device, index) => (
                                                        <tr key={index}>
                                                            <td>{device?.user?.project_name}</td>
                                                            <td>{device.device_id}</td>
                                                            <td>{device.name}</td>
                                                            <td>{device.system}</td>
                                                            <td>{device.temp_range}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
